import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core'
import { AppSignals } from '@appShared/services'

@Component({
    selector: 'app-site-footer',
    templateUrl: './site-footer.component.html',
    styleUrls: ['./site-footer.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class SiteFooterComponent {
   private _appSignals = inject(AppSignals)
   signedIn = computed(() => {
      const currentProfileContact = this._appSignals.currentProfile()?.contact
      if (!!!currentProfileContact) return undefined
      return `${currentProfileContact.firstName} ${currentProfileContact.lastName}`
   })
   currentYear = (new Date()).getFullYear()
}
